// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--1ZwYq";
export var btnBlock = "banner-module--btnBlock--US-Sd";
export var container = "banner-module--container--IX9yb";
export var gethalva = "banner-module--gethalva--UnMT4";
export var hideMobBlock = "banner-module--hideMobBlock---duWJ";
export var img = "banner-module--img--6TsrY";
export var indexPkw = "banner-module--indexPkw--8UcTJ";
export var isPKW = "banner-module--isPKW--ACbdn";
export var isPinkGetHalva = "banner-module--isPinkGetHalva--tmDiV";
export var mobBtn = "banner-module--mobBtn--G++d6";
export var secondContainer = "banner-module--secondContainer--w5v-S";
export var section = "banner-module--section--bXV38";
export var text = "banner-module--text--qsJ3G";